import { render, staticRenderFns } from "./IframeComponent.vue?vue&type=template&id=4ca5e948&scoped=true"
import script from "./IframeComponent.vue?vue&type=script&lang=js"
export * from "./IframeComponent.vue?vue&type=script&lang=js"
import style0 from "./IframeComponent.vue?vue&type=style&index=0&id=4ca5e948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5e948",
  null
  
)

export default component.exports